import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-extrabold text-gray-900">Privacy Policy</h1>

      <p className="mt-4 text-gray-700 leading-relaxed">
        Your privacy is important to us. This page explains how we collect, use,
        and protect your personal data.
      </p>

      <h2 className="mt-6 text-xl font-semibold text-gray-800">
        Information We Collect
      </h2>
      <p className="mt-2 text-gray-700">
        We may collect minimal personal information, such as your email address,
        when you interact with our website.
      </p>

      <h2 className="mt-6 text-xl font-semibold text-gray-800">
        How We Use Your Information
      </h2>
      <p className="mt-2 text-gray-700">
        We use collected data to improve our services, personalize content, and
        ensure a better user experience.
      </p>

      <h2 className="mt-6 text-xl font-semibold text-gray-800">
        Data Protection
      </h2>
      <p className="mt-2 text-gray-700">
        We implement security measures to protect your data, but we recommend
        using strong passwords and browsing securely.
      </p>

      <div className="mt-6 p-4 border-l-4 border-blue-500 bg-blue-50">
        <p className="text-gray-800 font-medium">
          By using this website, you agree to the collection and use of
          information as described in this policy.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
